export const getPostInstallationUrlWithQuery = ({
  appId,
  tenantId,
  postInstallationUrl,
}: {
  appId: string;
  tenantId: string;
  postInstallationUrl: string;
}): string | undefined => {
  try {
    const url = new URL(postInstallationUrl);
    url.searchParams.set('appId', appId);
    url.searchParams.set('tenantId', tenantId);

    return url.toString();
  } catch (e) {
    return;
  }
};
